type CategoryState = {
  classification?: string | null
  discontinuedAt?: string | null
}

export function isDiscontinued(rec: Pick<CategoryState, 'discontinuedAt'>): boolean {
  return Boolean(rec.discontinuedAt)
}

export function selectPrimaryRecommendation<T extends CategoryState>(recs: T[]): T | undefined {
  const primaries = recs.filter((rec) => rec.classification === 'primary')
  return (
    primaries.find((rec) => !isDiscontinued(rec)) ??
    primaries.sort((a, b) => (b.discontinuedAt ?? '').localeCompare(a.discontinuedAt ?? ''))[0]
  )
}

export function primaryCategoryValidationError(recs: CategoryState[]): string | undefined {
  const primaries = recs.filter((rec) => rec.classification === 'primary')
  if (primaries.filter((rec) => !isDiscontinued(rec)).length > 1) {
    return 'An app can have only one active Primary category.'
  }
  if (primaries.length === 0) {
    return 'An app must keep a Primary category. To change it, set another recommendation to Primary. To mark it discontinued, set Discontinued At instead of changing its classification or deleting it.'
  }
  return undefined
}
